// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2uKDz","badges":"styles_badges__1Wijw"};